import { CountryId } from '@/entities/country';
import { OperatorId } from '@/entities/operator';

const EMIRATES_OPERATORS = OperatorId.Travelata.join('.');

export const EMIRATES_SERP_URL = `/search#?toCountry=${CountryId.Uae}&block=true&f_operators=${EMIRATES_OPERATORS}`;
